export enum ContextKey {
    login = 'user-data',
    search = 'search',
    page = 'page'
}
